import { render, staticRenderFns } from "./IndicadorPresupuestosPropuestos.vue?vue&type=template&id=cf32a3a6&"
import script from "./IndicadorPresupuestosPropuestos.vue?vue&type=script&lang=js&"
export * from "./IndicadorPresupuestosPropuestos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports